<div
  class="ministerial-page"
  [class.ministerial-page--ministerial]="designVersion === 'ministerial'">
  <header class="page-heading">
    <button *ngIf="designVersion === 'ministerial'" mat-icon-button type="button"
      aria-label="Volver a eventos" matTooltip="Volver a eventos" (click)="onCancel()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div>
      <h2 *ngIf="!currentEvent">Registrar actividad ministerial</h2>
      <h2 *ngIf="currentEvent">Editar evento: {{ currentEvent.eventTypeName }}</h2>
    </div>
  </header>

  <section *ngIf="!showEventForm && designVersion !== 'ministerial'" class="event-picker">
    <div class="section-heading">
      <h3>¿Qué evento querés registrar?</h3>
    </div>

    <div class="action-list">
      <button
        *ngFor="let action of availableActions; trackBy: trackActionOption"
        type="button"
        class="action-option"
        [ngClass]="'action-option--' + action.group"
        [disabled]="isActionDisabled(action.value)"
        [matTooltip]="actionDisabledReason(action.value)"
        (click)="selectAction(action.value)">
        <mat-icon>{{ action.icon }}</mat-icon>
        <span>
          <strong>{{ action.label }}</strong>
          <small>{{ actionDisabledReason(action.value) || action.description }}</small>
        </span>
        <mat-icon class="action-option__arrow">chevron_right</mat-icon>
      </button>
    </div>
  </section>

  <form
    *ngIf="showEventForm || designVersion === 'ministerial'"
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
    class="registration-layout"
    [class.registration-layout--ministerial]="designVersion === 'ministerial'"
    [class.registration-layout--ministerial-has-designations]="designVersion === 'ministerial' && showEventForm"
    [class.registration-layout--ministerial-step-action]="designVersion === 'ministerial' && ministerialMobileStep === 'action'"
    [class.registration-layout--ministerial-step-form]="designVersion === 'ministerial' && ministerialMobileStep === 'form'"
    [class.registration-layout--ministerial-editing]="designVersion === 'ministerial' && !!currentEvent">
    <nav *ngIf="designVersion === 'ministerial' && showEventForm && !currentEvent" class="ministerial-mobile-steps" aria-label="Paso del formulario">
      <button mat-button type="button" [class.ministerial-mobile-step--active]="ministerialMobileStep === 'action'" (click)="goToMinisterialMobileStep('action')">Acción</button>
      <button mat-button type="button" [class.ministerial-mobile-step--active]="ministerialMobileStep === 'form'" (click)="goToMinisterialMobileStep('form')">Datos</button>
    </nav>

    <mat-form-field *ngIf="designVersion === 'ministerial' && !currentEvent" class="ministerial-mobile-action-select">
      <mat-label>Acción</mat-label>
      <mat-select formControlName="action" placeholder="Seleccionar acción" required>
        <mat-option
          *ngFor="let action of availableActions; trackBy: trackActionOption"
          [value]="action.value"
          [disabled]="isActionDisabled(action.value)">
          {{ action.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <aside *ngIf="designVersion === 'ministerial' && !currentEvent" class="ministerial-action-column">
      <mat-form-field class="action-filter-field" subscriptSizing="dynamic">
        <mat-label>Filtrar acciones</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input matInput [formControl]="actionFilterControl" />
        <button
          *ngIf="actionFilterControl.value"
          mat-icon-button
          matSuffix
          type="button"
          aria-label="Limpiar filtro"
          (click)="clearActionFilter()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <div class="action-list action-list--ministerial">
        <button
          *ngFor="let action of availableActions; trackBy: trackActionOption"
          type="button"
          class="action-option"
          [class.action-option--selected]="selectedAction === action.value"
          [ngClass]="'action-option--' + action.group"
          [disabled]="isActionDisabled(action.value)"
          [matTooltip]="actionDisabledReason(action.value) || action.description"
          (click)="selectAction(action.value)">
          <mat-icon>{{ action.icon }}</mat-icon>
          <span>
            <strong>{{ action.label }}</strong>
            <small>{{ actionDisabledReason(action.value) || action.description }}</small>
          </span>
        </button>
        <p *ngIf="availableActions.length === 0" class="action-list__empty">
          No hay acciones que coincidan con el filtro.
        </p>
      </div>
    </aside>

    <section *ngIf="designVersion === 'ministerial' && !showEventForm" class="ministerial-empty-form">
      <mat-icon>dynamic_form</mat-icon>
      <strong>Seleccioná una acción</strong>
      <span>El formulario se va a mostrar en esta columna con los campos que correspondan.</span>
    </section>

    <main
      *ngIf="showEventForm"
      class="registration-card registration-card--compact">
      <div class="selected-event">
        <div class="selected-event__identity">
          <mat-icon>{{ selectedActionOption?.icon }}</mat-icon>
          <strong>{{ selectedActionOption?.label }}</strong>
        </div>
        <button *ngIf="mode === 'change' && designVersion !== 'ministerial'" mat-button type="button" (click)="onBackToActions()">Cambiar evento</button>
      </div>

      <div class="form-sections">
        <div class="activity-form">
          <div class="activity-field">
            <span class="activity-label">Fecha efectiva <span aria-hidden="true">*</span></span>
            <div class="activity-control activity-control--embedded">
              <app-date-picker label="Fecha efectiva" [compact]="true" formControlName="eventDate"></app-date-picker>
            </div>
          </div>

          <div *ngIf="requiresExpectedEndDate || isLicenseEndDateAction || (currentEvent && isNewOfficiantAction)" class="activity-field">
            <span class="activity-label">Fecha de finalización <span *ngIf="requiresExpectedEndDate" aria-hidden="true">*</span><small *ngIf="!requiresExpectedEndDate">Opcional</small></span>
            <div class="activity-control activity-control--embedded">
              <app-date-picker label="Fecha de finalización" [compact]="true" [min]="form.controls.eventDate.value" formControlName="expectedEndDate"></app-date-picker>
            </div>
          </div>

          <div *ngIf="isInstitutionAction" class="activity-field">
            <span id="institution-ministry-label" class="activity-label">Ministerio <span aria-hidden="true">*</span></span>
            <mat-form-field appearance="fill" subscriptSizing="dynamic">
              <mat-select aria-labelledby="institution-ministry-label" placeholder="Seleccionar ministerio"
                [value]="institutionMinistryId" (selectionChange)="onInstitutionMinistryChanged($event.value)" required>
                <mat-select-trigger>{{ institutionMinistryName }}</mat-select-trigger>
                <mat-option *ngFor="let ministry of ministries" [value]="ministry.id">
                  {{ ministry.name }}
                  <span *ngIf="ministry.isActive === false" class="inactive-option-label">Inactivo</span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div *ngIf="isInstitutionAction" class="activity-field">
            <span class="activity-label">Áreas de actividad <span aria-hidden="true">*</span></span>
            <div class="activity-unit-multiple">
              <app-unit-selector label="Áreas de actividad" [multiple]="true" [hideLabel]="true" [compactStyle]="true"
                [allowFreeText]="true" freeTextLabel="área histórica"
                [required]="true" [showClearButton]="false" placeholder="Buscar unidades o escribir un área histórica" [unitSource]="'all'" [suggestedUnits]="suggestedActivityUnits"
                [allowedLevelIds]="allowedLevelsForDesignation(0)" [groupByLevel]="true" groupByMode="ancestors"
                formControlName="institutionAreaIds" (unitsChange)="onInstitutionUnitsChanged($event)"></app-unit-selector>
            </div>
          </div>

          <ng-container *ngIf="!isInstitutionAction && isLicenseRenewalAction">
            <div *ngIf="currentLicenseContext as license; else noCurrentLicense" class="current-license-card">
              <div class="current-license-card__item">
                <span>Ministerio</span>
                <strong>{{ license.ministryName || effectiveCurrentMinistry?.ministryName || 'Ministerio vigente' }}</strong>
              </div>
              <div class="current-license-card__item">
                <span>Licencia vigente desde</span>
                <strong>{{ formatIsoDateLabel(license.startDate) }}</strong>
              </div>
              <div class="current-license-card__item">
                <span>Finalización actual</span>
                <strong>{{ formatIsoDateLabel(license.endDate) }}</strong>
              </div>
            </div>

            <ng-template #noCurrentLicense>
              <div class="retained-warning">
                <mat-icon>info</mat-icon>
                <p>Elegí una fecha efectiva dentro de una licencia ministerial vigente.</p>
              </div>
            </ng-template>
          </ng-container>

          <div *ngIf="shouldHideReinstatementFields" class="form-state-message">
            <mat-icon>info</mat-icon>
            <span>{{ reinstatementDateMessage }}</span>
          </div>
          <section *ngIf="!isInstitutionAction && requiresDesignations && !shouldHideReinstatementFields" class="form-panel designations-panel">
            <div class="form-panel__content">

              <div *ngIf="isReassignment" class="reassignment-details">
                <div *ngIf="reassignmentClosingDesignations.length" class="reassignment-details__warning">
                  <mat-icon>info</mat-icon>
                  <span>
                    Solo se reasignará el área del ministerio. También se finalizarán los encargos y nombramientos vigentes:
                    {{ reassignmentClosingDesignationsLabel }}.
                    Si corresponde, registralos nuevamente mediante una ordenación.
                  </span>
                </div>

              </div>

              <div *ngIf="isAppointmentEndAction" class="designation-end-list">
                <p class="designation-end-list__intro">Seleccioná los encargos o nombramientos que querés finalizar.</p>

                <article *ngFor="let designation of activeAppointableDesignations" class="designation-card designation-card--appointment-end">
                  <div class="designation-row designation-row--appointment-end">
                    <div class="designation-activity-field designation-activity-field--readonly">
                      <span>Designación</span>
                      <strong>{{ designation.referenceName }}</strong>
                    </div>
                    <div class="designation-area-card">
                      <div class="designation-area-card__copy">
                        <span>Área de actividad</span>
                        <strong>{{ designation.organizationUnitName }}</strong>
                      </div>
                      <mat-checkbox
                        color="primary"
                        [checked]="isDesignationSelectedToEnd(designation)"
                        (change)="toggleDesignationToEnd(designation, $event.checked)"
                        [aria-label]="'Finalizar ' + designation.referenceName + ' en ' + designation.organizationUnitName">
                      </mat-checkbox>
                    </div>
                  </div>
                </article>

                <p *ngIf="activeAppointableDesignations.length === 0" class="empty-designations">
                  No hay encargos ni nombramientos vigentes para finalizar en la fecha seleccionada.
                </p>
              </div>

              <div *ngIf="!isAppointmentEndAction" formArrayName="designations" class="designation-list">
                <article
                  *ngFor="let designation of designations.controls; let index = index"
                  [formGroupName]="index"
                  class="designation-card"
                  [class.designation-card--foldable]="isAppointmentAssignmentAction && designations.length > 1"
                  [class.designation-card--reinstatement-readonly]="isReinstatement && !isDesignationEditing(index)">
                  <header *ngIf="isAppointmentAssignmentAction && designations.length > 1" class="designation-summary">
                    <button type="button" class="designation-summary__toggle"
                      [attr.aria-expanded]="isDesignationExpanded(index)" [attr.aria-controls]="'designation-content-' + index"
                      [disabled]="!isDesignationComplete(index)" (click)="toggleDesignationExpanded(index)">
                      <mat-icon>{{ isDesignationExpanded(index) ? 'expand_more' : 'chevron_right' }}</mat-icon>
                      <span class="designation-summary__copy">
                        <strong>{{ designationSummaryTitle(index) }}</strong>
                        <small [class.designation-summary__pending]="!isDesignationComplete(index)">
                          {{ isDesignationComplete(index) ? designationAreaSummary(index) : 'Pendiente de completar' }}
                        </small>
                      </span>
                    </button>
                    <button *ngIf="!isDesignationExpanded(index)" mat-icon-button type="button"
                      class="designation-summary__edit" [attr.aria-label]="'Editar ' + designationSummaryTitle(index)"
                      (click)="expandDesignation(index)">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button type="button" class="designation-summary__delete"
                      [attr.aria-label]="'Eliminar ' + designationSummaryTitle(index)" (click)="removeDesignation(index)">
                      <mat-icon>delete_outline</mat-icon>
                    </button>
                  </header>
                  <div [id]="'designation-content-' + index" [hidden]="!isDesignationExpanded(index)" class="designation-content">
                  <div class="designation-row">
                    <div *ngIf="!isReassignment && (!isReinstatement || isDesignationEditing(index)); else fixedDesignation" class="activity-field designation-activity-field">
                      <span [id]="'designation-label-' + index" class="activity-label">{{ designationFieldLabel }} <span aria-hidden="true">*</span></span>
                      <mat-form-field appearance="fill" subscriptSizing="dynamic">
                        <mat-select *ngIf="isAppointmentAssignmentAction; else designationSearch"
                          [attr.aria-labelledby]="'designation-label-' + index" placeholder="Seleccionar encargo o nombramiento"
                          formControlName="activitySearch" (selectionChange)="onDesignationActivitySelected(index, $event.value)" required>
                          <mat-optgroup *ngFor="let group of designationActivityGroups(index); trackBy: trackActivityGroup" [label]="group.label">
                            <mat-option *ngFor="let option of group.options; trackBy: trackActivityOption"
                              [value]="activitySelectionValue(option.kind, option.id)">
                              {{ option.name }}
                              <span *ngIf="!option.isActive" class="inactive-option-label">Inactivo</span>
                            </mat-option>
                          </mat-optgroup>
                        </mat-select>
                        <ng-template #designationSearch>
                        <input
                          matInput
                          required
                          [attr.aria-labelledby]="'designation-label-' + index"
                          placeholder="Buscar y seleccionar"
                          formControlName="activitySearch"
                          [matAutocomplete]="activityAutocomplete"
                          (input)="onDesignationActivityInput(index)" />
                        <mat-autocomplete
                          #activityAutocomplete="matAutocomplete"
                          panelClass="ministerial-activity-autocomplete-panel"
                          [displayWith]="displayActivitySelection"
                          (optionSelected)="onDesignationActivitySelected(index, $event.option.value)">
                          <mat-optgroup
                            *ngFor="let group of designationActivityGroups(index); trackBy: trackActivityGroup"
                            [label]="group.label">
                            <mat-option
                              *ngFor="let option of group.options; trackBy: trackActivityOption"
                              [value]="activitySelectionValue(option.kind, option.id)">
                              {{ option.name }}
                              <span *ngIf="!option.isActive" class="inactive-option-label">Inactivo</span>
                            </mat-option>
                          </mat-optgroup>
                        </mat-autocomplete>
                        </ng-template>
                        <mat-error>Requerido</mat-error>
                      </mat-form-field>
                    </div>

                    <div *ngIf="usesMultipleUnitSelection(index)" class="activity-field">
                      <span class="activity-label">Áreas de actividad <span aria-hidden="true">*</span></span>
                      <div class="activity-unit-multiple">
                        <app-unit-selector label="Áreas de actividad" [multiple]="true" [hideLabel]="true" [compactStyle]="true"
                          [allowFreeText]="isReinstatement" freeTextLabel="área histórica"
                          [required]="true" [showClearButton]="false" placeholder="Buscar y agregar unidades" [unitSource]="'all'" [suggestedUnits]="suggestedActivityUnits"
                          [allowedLevelIds]="allowedLevelsForDesignation(index)" [groupByLevel]="true" groupByMode="ancestors"
                          formControlName="selectedAreaIds" (unitsChange)="onDesignationUnitsChanged(index, $event)"></app-unit-selector>
                      </div>
                      <small *ngIf="designation.controls['selectedAreaIds'].touched && designation.controls['selectedAreaIds'].hasError('required')" class="activity-place-hint">Seleccioná al menos un área de actividad.</small>
                    </div>

                    <ng-template #fixedDesignation>
                      <div class="designation-activity-field designation-activity-field--readonly">
                        <span>{{ isReinstatement || isReassignment ? 'Ministerio' : 'Designación' }}</span>
                        <strong>{{ designationName(index) }}</strong>
                        <button *ngIf="isReinstatement" mat-button type="button" (click)="modifyDesignation(index)">
                          <mat-icon>edit</mat-icon>
                          Modificar
                        </button>
                      </div>
                    </ng-template>

                    <div *ngIf="isAppointmentAssignmentAction" class="activity-field">
                      <span class="activity-label">Fecha de finalización <small>Opcional</small></span>
                      <div class="activity-control activity-control--embedded">
                        <app-date-picker label="Fecha de finalización" [compact]="true"
                          formControlName="designationEndDate"></app-date-picker>
                      </div>
                      <small *ngIf="designation.controls['designationEndDate'].touched && designation.controls['designationEndDate'].hasError('endBeforeStart')"
                        class="activity-place-hint">La finalización debe ser posterior a la fecha efectiva.</small>
                    </div>

                    <div
                      *ngIf="!usesMultipleUnitSelection(index) && !showExpandedAreas(index) && !showInlineAreaEditor(index)"
                      class="designation-area-card">
                      <div class="designation-area-card__copy">
                        <span>{{ isReassignment ? 'Área actual' : 'Área de actividad' }}</span>
                        <strong>{{ isReassignment ? specificAreaName(index, 0) : firstAreaName(index) }}</strong>
                      </div>
                      <button *ngIf="!isReassignment && !isReinstatement" mat-button type="button" (click)="modifyDesignationArea(index)">
                        <mat-icon>edit</mat-icon>
                        Modificar
                      </button>
                      <button *ngIf="isReinstatement" mat-button type="button" (click)="modifyDesignation(index)">
                        <mat-icon>edit</mat-icon>
                        Modificar
                      </button>
                      <button *ngIf="isReassignment" mat-button type="button" (click)="startSpecificAreaPass(index, 0)">
                        <mat-icon>swap_horiz</mat-icon>
                        Hacer pase
                      </button>
                    </div>

                    <div
                      *ngIf="!usesMultipleUnitSelection(index) && showInlineAreaEditor(index)"
                      formArrayName="specificAreas"
                      class="inline-area-editor">
                      <div [formGroupName]="0" class="inline-area-editor__field">
                        <ng-container *ngIf="isReassignment" [ngTemplateOutlet]="reassignmentAreaSelector"
                          [ngTemplateOutletContext]="{ designationIndex: index, areaIndex: 0 }"></ng-container>
                        <mat-radio-group
                          *ngIf="!isReassignment && isHistoricalSpecificArea(index, 0)"
                          class="specific-area-mode"
                          formControlName="areaMode"
                          (change)="onSpecificAreaModeChanged(index, 0)">
                          <mat-radio-button value="unit">Unidad actual</mat-radio-button>
                          <mat-radio-button value="historical">Área histórica</mat-radio-button>
                        </mat-radio-group>
                        <div *ngIf="!isReassignment && !isHistoricalSpecificArea(index, 0)" class="activity-field">
                          <span class="activity-label">Área de actividad <span aria-hidden="true">*</span></span>
                          <div class="activity-control activity-control--embedded">
                            <app-unit-selector
                              label="Área de actividad" [hideLabel]="true" [compactStyle]="true" placeholder="Buscar unidad"
                              [required]="true"
                              [unitSource]="'all'" [suggestedUnits]="suggestedActivityUnits"
                              [allowedLevelIds]="allowedLevelsForDesignation(index)"
                              [groupByLevel]="true"
                              groupByMode="ancestors"
                              [showClearButton]="false"
                              formControlName="organizationUnitId"
                              (unitChange)="onSpecificAreaChanged($event)">
                            </app-unit-selector>
                          </div>
                        </div>
                        <div *ngIf="!isReassignment && isHistoricalSpecificArea(index, 0)" class="activity-field specific-historical-area-field">
                          <span class="activity-label">Nombre del área histórica <span aria-hidden="true">*</span></span>
                          <mat-form-field appearance="fill" subscriptSizing="dynamic">
                            <input matInput aria-label="Nombre del área histórica" required formControlName="historicalOrganizationUnitName" placeholder="Ingresar nombre del área" />
                            <mat-hint>Usalo solo si esa unidad no existe en la estructura actual.</mat-hint>
                          </mat-form-field>
                        </div>
                      </div>
                      <button *ngIf="!isReassignment" mat-button type="button" (click)="addSpecificArea(index)">
                        <mat-icon>add</mat-icon>
                        Agregar área
                      </button>
                    </div>

                    <button
                      *ngIf="!isAppointmentAssignmentAction && canRemoveDesignation(index)"
                      mat-icon-button
                      type="button"
                      class="designation-delete-button"
                      (click)="removeDesignation(index)"
                      aria-label="Eliminar designación">
                      <mat-icon>delete_outline</mat-icon>
                    </button>
                  </div>

                <div *ngIf="!usesMultipleUnitSelection(index) && showExpandedAreas(index)" class="specific-area-block">
                    <div class="specific-area-block__heading">
                      <div>
                        <strong>Áreas de actividad</strong>
                      </div>
                      <button *ngIf="!isReassignment" mat-button type="button" (click)="addSpecificArea(index)">
                        <mat-icon>add</mat-icon>
                        Agregar área
                      </button>
                    </div>

                    <div formArrayName="specificAreas" class="specific-area-list">
                      <div
                        *ngFor="let area of specificAreas(index).controls; let areaIndex = index"
                        [formGroupName]="areaIndex"
                        class="specific-area-row">
                        <div
                          *ngIf="isReassignment && !isSpecificAreaEditing(index, areaIndex)"
                          class="designation-area-card"
                          style="grid-column: 1 / -1">
                          <div class="designation-area-card__copy">
                            <span>Área actual</span>
                            <strong>{{ specificAreaName(index, areaIndex) }}</strong>
                          </div>
                          <button mat-button type="button" (click)="startSpecificAreaPass(index, areaIndex)">
                            <mat-icon>swap_horiz</mat-icon>
                            Hacer pase
                          </button>
                        </div>
                        <ng-container *ngIf="isReassignment && isSpecificAreaEditing(index, areaIndex)"
                          [ngTemplateOutlet]="reassignmentAreaSelector"
                          [ngTemplateOutletContext]="{ designationIndex: index, areaIndex: areaIndex }"></ng-container>
                        <mat-radio-group
                          *ngIf="!isReassignment && isHistoricalSpecificArea(index, areaIndex)"
                          class="specific-area-mode"
                          formControlName="areaMode"
                          (change)="onSpecificAreaModeChanged(index, areaIndex)">
                          <mat-radio-button value="unit">Unidad actual</mat-radio-button>
                          <mat-radio-button value="historical">Área histórica</mat-radio-button>
                        </mat-radio-group>
                        <div *ngIf="!isReassignment && !isHistoricalSpecificArea(index, areaIndex)" class="activity-field">
                          <span class="activity-label">Área de actividad <span aria-hidden="true">*</span></span>
                          <div class="activity-control activity-control--embedded">
                            <app-unit-selector
                              label="Área de actividad" [hideLabel]="true" [compactStyle]="true" placeholder="Buscar unidad"
                              [required]="true"
                              [unitSource]="'all'" [suggestedUnits]="suggestedActivityUnits"
                              [allowedLevelIds]="allowedLevelsForDesignation(index)"
                              [groupByLevel]="true"
                              groupByMode="ancestors"
                              [showClearButton]="false"
                              formControlName="organizationUnitId"
                              (unitChange)="onSpecificAreaChanged($event)">
                            </app-unit-selector>
                          </div>
                        </div>
                        <div *ngIf="!isReassignment && isHistoricalSpecificArea(index, areaIndex)" class="activity-field specific-historical-area-field">
                          <span class="activity-label">Nombre del área histórica <span aria-hidden="true">*</span></span>
                          <mat-form-field appearance="fill" subscriptSizing="dynamic">
                            <input matInput aria-label="Nombre del área histórica" required formControlName="historicalOrganizationUnitName" placeholder="Ingresar nombre del área" />
                            <mat-hint>Usalo solo si esa unidad no existe en la estructura actual.</mat-hint>
                          </mat-form-field>
                        </div>
                        <button
                          *ngIf="!isReassignment && specificAreas(index).length > 1"
                          mat-icon-button
                          type="button"
                          (click)="removeSpecificArea(index, areaIndex)"
                          aria-label="Quitar área">
                          <mat-icon>delete_outline</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                  </div>
                </article>

                <button *ngIf="!isReassignment && !isSingleMinistryAssignmentAction && !isReinstatement" mat-button type="button" class="add-designation-button add-designation-button--below" (click)="addDesignation()">
                  <mat-icon>add</mat-icon>
                  {{ isAppointmentAssignmentAction ? 'Agregar otro encargo / nombramiento' : 'Agregar designación' }}
                </button>
              </div>

              <p *ngIf="!isAppointmentEndAction && designations.length === 0 && designationsRequired" class="empty-designations">
                Agregá al menos una designación para continuar.
              </p>
              <p *ngIf="!isAppointmentEndAction && designations.length === 0 && !designationsRequired" class="empty-designations">
                Sin nuevas designaciones: se conservarán las que ya están vigentes.
              </p>
            </div>
          </section>

          <ng-template #reassignmentAreaSelector let-designationIndex="designationIndex" let-areaIndex="areaIndex">
            <div class="activity-field" style="grid-column: 1 / -1">
              <span class="activity-label">Áreas de actividad <span aria-hidden="true">*</span></span>
              <div class="activity-unit-multiple">
                <app-unit-selector label="Áreas de actividad" [multiple]="true" [allowFreeText]="true"
                  freeTextLabel="área histórica" [hideLabel]="true" [compactStyle]="true" [required]="true"
                  [showClearButton]="false" placeholder="Buscar unidades o escribir un área histórica" [unitSource]="'all'" [suggestedUnits]="suggestedActivityUnits"
                  [allowedLevelIds]="allowedLevelsForDesignation(designationIndex)" [groupByLevel]="true" groupByMode="ancestors"
                  [formControl]="reassignmentDestinationsControl(designationIndex, areaIndex)"
                  (unitsChange)="onReassignmentDestinationsChanged(designationIndex, areaIndex, $event)"></app-unit-selector>
              </div>
              <small *ngIf="reassignmentDestinationsControl(designationIndex, areaIndex).touched && reassignmentDestinationsControl(designationIndex, areaIndex).invalid"
                class="activity-place-hint">Seleccioná al menos un área. Los nombres históricos admiten hasta 200 caracteres.</small>
            </div>
          </ng-template>

          <div *ngIf="showEventDetailsFields && requiresOfficiantArea" class="activity-field">
            <span class="activity-label">Área de actividad <span aria-hidden="true">*</span></span>
            <div class="activity-control activity-control--embedded">
              <app-unit-selector label="Área de actividad" [hideLabel]="true" [compactStyle]="true"
                [required]="true" placeholder="Buscar comunidad" [unitSource]="'all'" [suggestedUnits]="suggestedActivityUnits" [levelId]="5"
                [groupByLevel]="true" groupByMode="ancestors" formControlName="actOrganizationUnitId"
                (unitChange)="onActOrganizationUnitChanged($event)"></app-unit-selector>
            </div>
          </div>

          <div *ngIf="showEventDetailsFields && !requiresOfficiantArea" class="activity-field">
            <span class="activity-label">Lugar del acto <small>{{ requiresActPlace ? 'Requerido' : 'Opcional' }}</small></span>
            <div class="activity-control activity-control--embedded">
              <app-unit-selector label="Lugar del acto" [hideLabel]="true" [compactStyle]="true" [required]="requiresActPlace"
                [allowFreeText]="true" freeTextLabel="otro lugar" placeholder="Buscar comunidad o escribir otro lugar"
                [unconfirmedFreeText]="form.controls.eventActPlace.hasError('unconfirmedPlace')"
                [unitSource]="'all'" [suggestedUnits]="suggestedActivityUnits" [levelId]="5" [groupByLevel]="true" groupByMode="ancestors"
                formControlName="eventActPlace" (selectionChange)="onEventActPlaceChanged($event)"></app-unit-selector>
            </div>
            <small *ngIf="form.controls.eventActPlace.hasError('unconfirmedPlace')" class="activity-place-hint">Elegí una comunidad o usá el texto como otro lugar.</small>
            <small *ngIf="form.controls.actLocation.hasError('maxlength')" class="activity-place-hint">El lugar puede tener hasta 200 caracteres.</small>
          </div>

          <div *ngIf="showEventDetailsFields" class="activity-field">
            <label for="activity-comment" class="activity-label">Comentario <small>{{ requiresComment ? 'Requerido' : 'Opcional' }}</small></label>
            <textarea id="activity-comment" class="activity-control activity-text" formControlName="reason"
              rows="1" placeholder="Agregar comentario" [required]="requiresComment"></textarea>
          </div>
        </div>
      </div>

      <footer class="form-actions">
        <button mat-button type="button" class="ministerial-mobile-back-button" (click)="goToMinisterialMobileStep('action')">Atrás</button>
        <button mat-flat-button color="primary" type="submit" [disabled]="submitDisabled">
          <mat-spinner *ngIf="isSaving() || isValidationPending" diameter="18"></mat-spinner>
          <span>{{ isInstitutionAction && !currentEvent ? 'Registrar institución' : submitButtonLabel }}</span>
        </button>
      </footer>
    </main>

  </form>
</div>
